var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook icon"),React.createElement("path",{"d":"M105.6 210.9c-14.6 0-28.3-2.7-41.1-8.2-12.8-5.5-24-13-33.5-22.5s-17-20.6-22.5-33.5C3 133.9.3 120.2.3 105.6.3 91 3 77.3 8.5 64.5c5.5-12.8 13-24 22.5-33.6 9.5-9.6 20.6-17.1 33.5-22.6C77.3 2.8 91 0 105.6 0c14.6 0 28.3 2.8 41.1 8.2 12.8 5.5 23.9 13 33.5 22.6 9.5 9.6 17 20.8 22.5 33.6s8.2 26.5 8.2 41.1c0 14.6-2.8 28.3-8.2 41.1-5.5 12.8-13 24-22.5 33.5s-20.7 17-33.5 22.5c-12.8 5.6-26.5 8.3-41.1 8.3zM78.3 109.2h15.6v47.4h19.5v-47.4h19.5V89.7h-19.5v-9.9c0-1.6.4-3 1.2-4.2.8-1.2 1.7-1.8 2.7-1.8h15.6V54.6h-15.6c-6.4 0-11.9 2.5-16.5 7.5s-6.9 11-6.9 18v9.6H78.3v19.5z","key":1})]);
}

Facebook.defaultProps = {"viewBox":"0 0 210.9 210.9"};

module.exports = Facebook;

Facebook.default = Facebook;
